<!--
For payment embeded app loader is not showing due to css conflicts, so to fix this,
add embeded class for payment for now, later we can extend
-->
@if (appFacadeService.getLoader() | async) {
<div class="preloader" [ngClass]="{ embeded: (appFacadeService.getRedirection() | async)?.toLoad === 'Payment' }">
    <div class="loader"></div>
</div>
}
